import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DiscountComponent } from './discount.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Ng2SearchPipeModule } from 'ng2-search-filter';
import {AdddiscountComponent} from 'src/app/modules/discount/adddiscount/adddiscount.component'
import { PaginationModule } from 'ngx-bootstrap';

@NgModule({
  declarations: [DiscountComponent, AdddiscountComponent],
  imports: [
    CommonModule,
    PaginationModule.forRoot(),
    NgxPaginationModule,
    FormsModule,
    ReactiveFormsModule,
    Ng2SearchPipeModule,
  ]
})
export class DiscountModule { }
